module.exports = __webpack_public_path__ + "images/mstile-144x144.c6cda5359e0ea0edd28dd3984710a5d4.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/mstile-144x144.png
// module id = 1001
// module chunks = 0